import React from 'react';

export default function Navbar({ user, onLogout, serverStatus }) {
  const statusColor = serverStatus?.status === 'healthy' ? 'bg-emerald-400' : 'bg-red-400';

  return (
    <header className="sticky top-0 z-50 glass shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-md shadow-blue-500/20">
              <span className="text-lg">💰</span>
            </div>
            <div>
              <h1 className="text-lg font-bold gradient-text">FinanceAI</h1>
            </div>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-4">
            {/* Server status pill */}
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-slate-100 rounded-full">
              <div className={`w-2 h-2 rounded-full ${statusColor} animate-pulse`} />
              <span className="text-xs font-medium text-slate-600">
                {serverStatus?.status === 'healthy' ? 'API Online' : 'API Offline'}
              </span>
              {serverStatus?.gemini_enabled && (
                <span className="text-xs px-1.5 py-0.5 bg-purple-100 text-purple-700 rounded-full font-medium">
                  AI
                </span>
              )}
            </div>

            {/* User info */}
            <div className="flex items-center gap-3">
              <div className="hidden sm:block text-right">
                <p className="text-sm font-semibold text-slate-700">
                  {user?.firstName} {user?.lastName}
                </p>
                <p className="text-xs text-slate-400">{user?.email}</p>
              </div>

              <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full flex items-center justify-center text-white font-bold text-sm shadow">
                {user?.firstName?.[0]}{user?.lastName?.[0]}
              </div>

              <button
                onClick={onLogout}
                className="px-3 py-1.5 text-sm font-medium text-slate-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition"
                title="Sign Out"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
